const JsonLd = ({ data }) => {
  if (!data || typeof data !== 'object') return null;

  const safeJson = (() => {
    try {
      const str = JSON.stringify(data);
      return str.replace(/<\/script/gi, '<\\/script');
    } catch {
      return null;
    }
  })();

  if (!safeJson) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJson }}
    />
  );
};

export default JsonLd;
